import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setParametrosPago } from 'redux/actions/cotizacion.actions';

/**
 * @deprecated este metodo ya no se debeeria usar, debido a que la forma en la que maneja la peticion de parametros, no tiene control de errores ni control de loading global.
 * Se recomienda usar el useParametrosPagos.js
 * @param string codProducto
 * @returns {{loading:boolean,fetchParametros:CallableFunction}}
 */
const useConsultarParametrosPago = (codProducto, idCotizacion=null) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const init = async () => {
    const DataParametros = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'obtenerParametros',
        prodCodigo: codProducto,
        //polCodigo: idPoliza,
        idCotizacion:idCotizacion,
        numTarjeta: '4656565',
      },
    };
    setLoading(true);
    const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.pago, DataParametros);
    if (res.transaccion) {
      dispatch(setParametrosPago(res.pago));
    }
  };

  return {
    loading,
    fetchParametros: init,
  };
};

export default useConsultarParametrosPago;
